export const MODIFY_EMAIL_VERIFIED = 'MODIFY_EMAIL_VERIFIED';

export function modifyEmailVerified(emailVerified){
    return{
        type: MODIFY_EMAIL_VERIFIED,
        mainState: {
            emailVerified: emailVerified
        }
    }
}